import { ICardSpot } from '@/types/spots/cardSpot';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalizeFirstLetter } from '@/utils/lib/firstLetterCapitalize';
import Image from 'next/image';
import Link from 'next/link';

export const CardSpot: React.FC<ICardSpot> = ({
  spotId,
  imageSrc,
  titleSpot,
  iconLocation,
  location,
  aliasUser,
  rating,
}): React.JSX.Element => {
  return (
    <Link href={`/spots/${spotId}`} title="Voir le spot">
      <div className="bg-zinc-800 rounded-lg overflow-hidden font-primary">
        <div className="relative h-48">
          <Image
            src={imageSrc}
            alt="Image du spot"
            title={`Image du spot ${titleSpot}`}
            className="absolute w-full h-full object-cover"
            width={500}
            height={500}
            quality={100}
            priority
          />
        </div>
        <div className="p-4 grid grid-cols-2">
          <h3
            id={`spot-title-${titleSpot}`}
            className="text-lg font-semibold text-white mb-3 col-span-1 lg:w-[12rem] md:w-[15rem] sm:w-[13rem]"
          >
            {titleSpot}
          </h3>
          <div className="col-span-1 text-right">
            <span className="bg-red-600 p-1 inline-flex rounded-lg items-center">
              <FontAwesomeIcon
                icon={faStar}
                className="size-4 mr-1 mb-0.5"
              ></FontAwesomeIcon>
              <meta content={rating!.toString()} />

              {rating}
            </span>
          </div>
          <p className="text-sm text-gray-400 flex items-center mb-3 col-span-2">
            <FontAwesomeIcon icon={iconLocation} className="mr-1 size-4 mb-1" />
            {location}
          </p>
          <p className="text-sm text-gray-400 col-span-2">
            Capturé par
            <span className="text-red-600 pl-1">
              {aliasUser ? capitalizeFirstLetter(aliasUser) : 'N/a'}
            </span>
          </p>
        </div>
      </div>
    </Link>
  );
};
